import { render, staticRenderFns } from "./SummaryList.vue?vue&type=template&id=5b948066&scoped=true"
import script from "./SummaryList.vue?vue&type=script&lang=js"
export * from "./SummaryList.vue?vue&type=script&lang=js"
import style0 from "./SummaryList.vue?vue&type=style&index=0&id=5b948066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b948066",
  null
  
)

export default component.exports